<template>
  <nav v-show="isNavBarVisible" id="navbar-main noprint" class="navbar is-fixed-top menu">
    <div class="navbar-brand">
      
      <a class="navbar-item is-hidden-desktop" @click.prevent="menuToggleMobile">
        <b-icon style="color: white;" :icon="menuToggleMobileIcon" />
      </a>
      <div class="navbar-text">
        MIG Holdings
      </div>
    </div>
    <!-- <div class="navbar-brand is-left">
      <div class="navbar-item">
        <a @click.prevent="menuNavBarToggle" style="color: white;">
          <b-icon :icon="menuNavBarToggleIcon" custom-size="default" custom-class="is-white" />
        </a>
      </div>
    </div> -->
    
  </nav>
  <!-- <div></div> -->
</template>

<script>
import NavBarMenu from '@/components/NavBarMenu';
import { mapState } from 'vuex';

export default {
  name: 'NavBar',
  components: {},
  data() {
    return {
      isMenuNavBarActive: false,
      noOfNewOrder: 0,
    };
  },
  created() {
    // this.$onSocket.on('newOrderAvailable', (res) => {
    //   this.noOfNewOrder = res;
    //   console.log(res);
    //   this.$store.dispatch('dashboard/getDashboard');
    // });
  },
  computed: {
    menuNavBarToggleIcon() {
      return this.isMenuNavBarActive ? 'close' : 'dots-vertical';
    },
    menuToggleMobileIcon() {
      return this.isAsideMobileExpanded ? 'chevron-left' : 'align-left';
    },
    ...mapState([
      'isNavBarVisible',
      'isAsideMobileExpanded',
      'noOfUnreadNotifications',
    ]),
  },
  methods: {
    menuToggleMobile() {
      this.$store.commit('asideMobileStateToggle');
    },
    menuNavBarToggle() {
      this.isMenuNavBarActive = !this.isMenuNavBarActive;
    },
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        
        this.$router.push({ path: '/login' });
        this.$forceUpdate();
        this.$buefy.snackbar.open({
          message: 'Logged Out Successfully',
          queue: false,
        });
      });
    },
  },
};
</script>

<style scoped>
/* .is-same-as-aside {
  background-image: linear-gradient(to right, #1e344c, #051d38);
} */

.is-white {
  color: white;
}

@media screen and (max-width: 900px) {
  .navbar-end {
    background-color: rgb(88, 53, 128);
  }
}

.navbar-item:hover {
  background-color: #4a5594;
}
.menutoggle {
  position: relative;
  float: left;
  width: 32px;
  height: 55px;
  font-size: 22px;
  color: #1d2939;
}
.badge {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 15px;
  font-weight: 800;
  line-height: 0.5;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 10px;
}
.navbar-text{
  color: white;
  font-size: 2em;
  font-weight: 400;
  line-height: 1.5;
  margin-left: 10px;
}
</style>
